import { Document, Page, Text, View, StyleSheet, pdf } from "@react-pdf/renderer"
import moment from "moment"
// import JsBarcode from "jsbarcode"

// const generateBarcodeBase64 = (value: string) => {
//   const canvas = document.createElement("canvas")
//   JsBarcode(canvas, value, {
//     displayValue: false,
//     width: 1,
//     height: 30,
//     margin: 0,
//   })
//   return canvas.toDataURL("image/png")
// }

const styles = StyleSheet.create({
  page: {
    padding: 20,
    fontSize: 8,
    fontFamily: "Helvetica"
  },
  header: {
    flexDirection: "row",
    backgroundColor: "#000",
    color: "#fff",
    fontWeight: "bold"
  },
  row: {
    flexDirection: "row",
    borderBottom: "1 solid #e5e7eb"
  },
  cell: {
    padding: 4
  },
  bold: {
    fontWeight: "bold"
  },
  gray: {
    backgroundColor: "#d1d5db"
  },
  lightGray: {
    backgroundColor: "#f3f4f6"
  }
})

const COL = {
  no: 20,
  date: 45,
  invoice: 70,
  customer: 60,
  location: 45,
  item: 55,
  desc: 110,
  qty: 30,
  unit: 40,
  price: 55,
  amount: 65,
  tax: 55,
  job: 70,
  cogm: 55,
  cogmAmount: 65,
  profit: 65
}

export default function ExportDataPDFAnalyseSalesPeriode({ data }: { data: any[] }) {
  let rowNumber = 1

  return (
    <Document>
      <Page size="A4" orientation="landscape" style={styles.page}>
        {/* HEADER */}
        <View style={styles.header}>
          <Text style={{ ...styles.cell, width: COL.no }}>NO</Text>
          <Text style={{ ...styles.cell, width: COL.date }}>DATE</Text>
          <Text style={{ ...styles.cell, width: COL.invoice }}>INVOICE</Text>
          <Text style={{ ...styles.cell, width: COL.customer }}>CUSTOMER</Text>
          <Text style={{ ...styles.cell, width: COL.location }}>LOCATION</Text>
          <Text style={{ ...styles.cell, width: COL.item }}>ITEM CODE</Text>
          <Text style={{ ...styles.cell, width: COL.desc }}>DESCRIPTION</Text>
          <Text style={{ ...styles.cell, width: COL.qty }}>QTY</Text>
          <Text style={{ ...styles.cell, width: COL.unit }}>UNIT</Text>
          <Text style={{ ...styles.cell, width: COL.price }}>PRICE</Text>
          <Text style={{ ...styles.cell, width: COL.amount }}>EXT AMOUNT</Text>
          <Text style={{ ...styles.cell, width: COL.tax }}>TAX</Text>
          <Text style={{ ...styles.cell, width: COL.job }}>JOB</Text>
          <Text style={{ ...styles.cell, width: COL.cogm }}>COGM</Text>
          <Text style={{ ...styles.cell, width: COL.cogmAmount }}>COGM AMOUNT</Text>
          <Text style={{ ...styles.cell, width: COL.profit }}>SALES PROFIT</Text>
        </View>

        {data.map(group => (
          <View key={group.transaction_date}>
            {/* DATE ROW */}
            <View style={[styles.row, styles.gray]}>
              <Text style={{ ...styles.cell, ...styles.bold }}>
                {moment(group.transaction_date).format("DD/MM/YYYY")}
              </Text>
            </View>

            {group.invoices.map((invoice: any) => (
              <View key={invoice.trx_code}>
                {/* INVOICE ROW */}
                <View style={[styles.row, styles.lightGray]}>
                  <Text style={{ ...styles.cell, ...styles.bold }}>
                    {invoice.trx_code}
                  </Text>
                </View>

                {/* ITEMS */}
                {invoice.items.map((item: any) => (
                  <View key={item.trx_code + rowNumber} style={styles.row}>
                    <Text style={{ ...styles.cell, width: COL.no }}>{rowNumber++}</Text>
                    <Text style={{ ...styles.cell, width: COL.date }}>
                      {moment(item.transaction_date).format("DD/MM/YYYY")}
                    </Text>
                    <Text style={{ ...styles.cell, width: COL.invoice }}>{item.trx_code}</Text>
                    <Text style={{ ...styles.cell, width: COL.customer }}>{item.customer_name}</Text>
                    <Text style={{ ...styles.cell, width: COL.location }}>{item.location_name}</Text>
                    <Text style={{ ...styles.cell, width: COL.location }}>{item.product_barcode}</Text>
                    {/* <View style={{ ...styles.cell, width: COL.item, alignItems: "center" }}>
                      <Image src={item.barcodeBase64} style={{ width: 30, height: 10 }} />
                    </View> */}
                    <Text style={{ ...styles.cell, width: COL.desc }}>{item.product_name}</Text>
                    <Text style={{ ...styles.cell, width: COL.qty }}>{item.quantity_invoice}</Text>
                    <Text style={{ ...styles.cell, width: COL.unit }}>{item.unit_sell_measure_name}</Text>
                    <Text style={{ ...styles.cell, width: COL.price }}>{item.price_invoice}</Text>
                    <Text style={{ ...styles.cell, width: COL.amount }}>{item.total}</Text>
                    <Text style={{ ...styles.cell, width: COL.tax }}>
                      {item.tax_name} ({item.tax_rate}%)
                    </Text>
                    <Text style={{ ...styles.cell, width: COL.job }}>{item.project_name}</Text>
                    <Text style={{ ...styles.cell, width: COL.cogm }}>{item.cogm}</Text>
                    <Text style={{ ...styles.cell, width: COL.cogmAmount }}>{item.cogm_amount}</Text>
                    <Text style={{ ...styles.cell, width: COL.profit }}>{item.sale_profit}</Text>
                  </View>
                ))}
              </View>
            ))}

            {/* TOTAL */}
            <View style={[styles.row, styles.lightGray]}>
              <Text style={{ ...styles.cell, ...styles.bold }}>
                Total {moment(group.transaction_date).format("DD/MM/YYYY")} | Qty: {group.total_quantity}
                {"  "} Amount: {group.total_amount}
                {"  "} COGM: {group.total_cogm_amount}
                {"  "} Profit: {group.total_sale_profit}
              </Text>
            </View>
          </View>
        ))}
      </Page>
    </Document>
  )
}

export async function ExportPDFAnalyseSalesPeriode(rawData: any[]) {
  //   const data = rawData.map(group => ({
  //   ...group,
  //   invoices: group.invoices.map((inv: any) => ({
  //     ...inv,
  //     items: inv.items.map((item: any) => ({
  //       ...item,
  //       barcodeBase64: generateBarcodeBase64(item.product_barcode),
  //     }))
  //   }))
  // }))

  const blob = await pdf(<ExportDataPDFAnalyseSalesPeriode data={rawData} />).toBlob()
  const url = URL.createObjectURL(blob)
  window.open(url)
}

export async function PrintPDFAnalyseSalesPeriode(rawData: any[]) {
  // const data = rawData.map(group => ({
  //   ...group,
  //   invoices: group.invoices.map((inv: any) => ({
  //     ...inv,
  //     items: inv.items.map((item: any) => ({
  //       ...item,
  //       barcodeBase64: generateBarcodeBase64(item.product_barcode),
  //     }))
  //   }))
  // }))
  const blob = await pdf(<ExportDataPDFAnalyseSalesPeriode data={rawData} />).toBlob()

  const iframe = document.createElement("iframe")
  iframe.style.position = "fixed"
  iframe.style.right = "0"
  iframe.style.bottom = "0"
  iframe.style.width = "0"
  iframe.style.height = "0"
  iframe.style.border = "0"

  iframe.src = URL.createObjectURL(blob)
  document.body.appendChild(iframe)

  iframe.onload = () => {
    iframe.contentWindow?.focus()
    iframe.contentWindow?.print()
  }
}
